import React, { useMemo } from "react";
import { AutocompleteMultiSelect, SelectOption } from "../AutocompleteMultiSelect/AutocompleteMultiSelect";
import { DealTableGroupByFields, ReportsQueries, RowBy } from "../../../store/types";
import { useGroupByContent } from "../../../hooks";

import { AutocompleteMeasures } from "../Set-table-columns/AutocompleteMeasures";

export type DataFormation = Partial<Pick<ReportsQueries, "groupBy" | "rowBy">>;

const rowByOptions: SelectOption<RowBy>[] = [
  { text: "Investor", key: "Investor", value: "investor" },
  { text: "Deal", key: "Deal", value: "deal" },
  { text: "Measure", key: "Measure", value: "measure" }
];

const dealViewRowByOptions: SelectOption<DealTableGroupByFields>[] = [
  { text: "Investor", key: "Investor", value: "investor" },
  { text: "Measure", key: "Measure", value: "measure" }
];

interface SetTableGroupByProps {
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
  isDealView?: boolean;
}

export const SetTableReportBy: React.FC<SetTableGroupByProps> = ({ onChangeDataFormation, isDealView }) => {
  const fields: Array<keyof ReportsQueries> = [isDealView ? "dealTableRowBy" : "rowBy", "measures", "calculatedFields"];

  const { setFieldValue, values } = useGroupByContent({ fields, onChangeDataFormation });

  const selectedOption = useMemo(() => {
    return rowByOptions.find((opt) => (isDealView ? values.dealTableRowBy === opt.value : values.rowBy === opt.value));
  }, [rowByOptions, values]);

  const groupByHasMeasures = isDealView ? values.dealTableRowBy === "measure" : values.rowBy === "measure";

  return (
    <div className="group-by-content">
      <div className="group-by-content__title">Select Report By</div>
      <div className="row">
        <div className="input-wrap">
          <AutocompleteMultiSelect
            defaultValue={selectedOption}
            label="Report by"
            disabledClean
            options={isDealView ? dealViewRowByOptions : rowByOptions}
            onChange={(value) => setFieldValue(isDealView ? "dealTableRowBy" : "rowBy", value)}
          />
        </div>
      </div>
      {groupByHasMeasures && (
        <div className="row">
          <div className="input-wrap">
            <AutocompleteMeasures
              label="Measures"
              queries={values}
              setQueryValue={setFieldValue}
              showGroups={["measures", "calculatedFields"]}
            />
          </div>
        </div>
      )}
    </div>
  );
};
